import { render, staticRenderFns } from "./SampleDatabase.vue?vue&type=template&id=45e1730c&scoped=true"
import script from "./SampleDatabase.vue?vue&type=script&lang=js"
export * from "./SampleDatabase.vue?vue&type=script&lang=js"
import style0 from "./SampleDatabase.vue?vue&type=style&index=0&id=45e1730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1730c",
  null
  
)

export default component.exports